// AboutPage — a page about the project in the Studio's middle, opened like
// a page (pen "Studio", scene "Info"): Info under the material's name (its
// purpose and details, opened from the outline's top row); Sources under
// its own name (opened from "N sources" in the top bar); Learning
// objectives under the material's name too (pen draws its coverage under
// the title). Pure: what it holds is rendered by the host.

export { AboutPage };

import { exhaustSwitchCase } from "@bilda/utils";
import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";
import type { DeskAbout } from "../Studio/studioDesk.js";

const AboutPage = ({
    about,
    title,
    children,
}: {
    readonly about: DeskAbout;
    // The material's name (the project's).
    readonly title: string;
    readonly children: ReactNode;
}): ReactNode => {
    const { t } = useLingui();
    const heading = ((): string => {
        switch (about) {
            case "info":
            case "objectives":
                return title;
            case "sources":
                return t`Sources`;
            default:
                return exhaustSwitchCase(about);
        }
    })();
    return (
        <article
            className="bilda-pages__page"
            aria-label={heading}
            data-kind={about}
        >
            <h1 className="bilda-pages__page-title" title={heading}>
                {heading}
            </h1>
            {children}
        </article>
    );
};
